/* eslint-disable no-loop-func */
/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Button, Spinner } from 'react-bootstrap';
import {
    getDocumentMetaWithDocId,
    deleteMultipleDocument,
    deleteDocument,
    downloadDoc,
    transformDocuments,
    unlockDocument,
} from './api/api';
import { useSelector, useDispatch } from 'react-redux';
import { inboxPage } from './_redux/actions/inboxActions';
import { outboxPage } from './_redux/actions/outboxActions';
import {
    GetFieldData,
    formatNameWithSpaceToUnderscore,
    getDropDownDataFromApi,
} from '../components/commonfunction';
import { getActions } from '../../_metronic/_helpers';
import { SpinnerBlur } from '../components/inbox/Spinner';

import EditDeleteModal from '../components/editpdf/EditDeleteModal';
import BreakPointModal from '../components/editpdf/BreakPointModal';
import { toast } from 'react-toastify';
import 'tui-image-editor/dist/tui-image-editor.css';
import 'tui-color-picker/dist/tui-color-picker.css';
import { getDocument } from 'pdfjs-dist';
import './_pdfWorker';

import Tooltip from '@material-ui/core/Tooltip';
import { useHistory, useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { deletedPage } from './_redux/actions/searchActions';
import UploadPagesModal from './modals/UploadPagesModal';
import ZoomModal from './modals/ZoomModal';
import { useOnScreen } from './hooks/useOnScreen';
import DraggablePage from './DraggablePage';
import {
    applyMerge,
    applySplit,
    applyBreak,
} from './_helpers/documentTransforms';

toast.configure();

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        fontSize: theme.typography.pxToRem(12),
        border: '1.5px solid #334F61 !important',
    },
}))(Tooltip);
var docidsCount = 0;
var cutCopyDocName = '';
var cutCopyParentId = '';
var deletedPages = [];

// Thumbnail rendering tuning. These directly control how fast the Split/Merge
// page loads PDF previews and how much memory the page uses.
//
// PDF pages are only displayed as thumbnails (and inside the hover tooltip at
// ~374x460 px). The zoom modal fetches a hi-res image from the server, so the
// thumbnail quality only needs to look good at the thumbnail size. Rendering
// every page at native (scale 1.0) resolution and then encoding it as a
// max-quality JPEG is what used to make this page slow and memory-heavy.
const PDF_THUMBNAIL_TARGET_WIDTH = 800; // px, viewport width at which we render
const PDF_THUMBNAIL_MAX_SCALE = 1.5; // cap so we never upscale small PDFs
const PDF_THUMBNAIL_JPEG_QUALITY = 0.85;
const PDF_RENDER_CONCURRENCY = 4; // pages rendered in parallel per doc

function MultipleEditPage(props) {
    const [imgUrlObj, setImgUrlObj] = useState([]);
    const [imgActiveUrlObj, setImgActiveUrlObj] = useState([]);
    const [showImage, setShowImage] = useState(false);
    const [documentToggle, setDocumentToggle] = useState(true);
    const [deleteText, setDeleteText] = useState('');
    const [blurSpinner, setBlurSpinner] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [showBreakPointPopup, setShowBreakPointPopup] = useState(false);
    const [resetDoc, setResetDoc] = useState([]);
    const [showBreakDoc, setShowBreakDoc] = useState(true);
    const [showMergeDoc, setShowMergeDoc] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [disableReset, setDisableReset] = useState(true);
    const [lastReset, setLastReset] = useState();
    const [showSaveButton, setShowSaveButton] = useState(false);
    const [selDocForBreak, setSelDocForBreak] = useState([]);
    const [lockedDocument, setLockedDocument] = useState([]);
    const [zoomOpen, setZoomOpen] = useState(false);
    const [zoomPage, setZoomPage] = useState(null);
    const [originalImgUrlObj, setOriginalImgUrlObj] = useState([]);

    const [deleteDocIds] = useState([]);
    var imageActiveUrl = imgActiveUrlObj;
    var pushSelectDatas = selectedData;
    const reduxStore = useSelector((state) => state);

    const allPagesRendered =
        imgUrlObj.length > 0 && imgUrlObj.every((doc) => !doc.loading);
    const anyDocLoading = imgUrlObj.some((doc) => doc.loading);

    const checkboxRef = useRef(null);
    const pendingRenderTargets = useRef(new Map());
    const latestPageHandlers = useRef({});
    const stablePageHandlers = useRef({
        activeImage: (...args) =>
            latestPageHandlers.current.activeImage(...args),
        setSeparator: (...args) =>
            latestPageHandlers.current.setSeparator(...args),
    });

    const configData = reduxStore.configReducerPersist.configData;
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const multipleID = useLocation().search;
    const editIds = new URLSearchParams(multipleID).get('editmultiple');

    const [targetDocId, setTargetDocId] = useState(null);
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const [allFields, setAllFields] = useState({});
    const [tagOptions, setTagOptions] = useState([]);
    const [attachmentTypeOptions, setAttachmentTypeOptions] = useState([]);
    const [openTagPickerFor, setOpenTagPickerFor] = useState(null);
    const [tagFilter, setTagFilter] = useState('');

    const ddl = useSelector((state) => state.persistDDL?.DDL ?? {});

    // Resolve the configured fieldIds for the per-document keywords we expose
    // in the labelling UI (Tags, Attachment Type, Fax Detail).  We look these
    // up by name so customer-specific fieldIds keep working.
    const metaFieldIds = React.useMemo(() => {
        const fields = configData?.fields ?? [];
        const findId = (label) =>
            fields.find(
                (f) =>
                    String(f?.name || '')
                        .trim()
                        .toLowerCase() === label.toLowerCase()
            )?.fieldId ?? null;
        return {
            tags: findId('Tags'),
            attachmentType: findId('Attachment Type'),
            faxDetail: findId('Fax Detail'),
        };
    }, [configData]);

    // Tag colour palette comes from configData.tags so chip colours match the
    // rest of the application.  Fall back to a neutral colour if a tag isn't
    // explicitly configured.
    const tagColorByName = React.useMemo(() => {
        const result = {};
        (configData?.tags ?? []).forEach((t) => {
            if (t?.name) result[String(t.name).toLowerCase()] = t.color;
        });
        return result;
    }, [configData]);

    useEffect(() => {
        setBlurSpinner(true);
        // eslint-disable-next-line no-unused-vars
        let fieldDataObj = GetFieldData({
            configData: configData,
        });

        // Pull the attachment-type / tag dropdowns from the persisted DDL store
        // populated when the user lands on the inbox.  We also fetch them on
        // demand below so the labelling UI keeps working when the page is
        // entered cold (e.g. via deep link / refresh).
        const dedupe = (values) =>
            (values || []).filter((v, i, arr) => v && arr.indexOf(v) === i);

        if (Array.isArray(ddl.tags) && ddl.tags.length > 0) {
            setTagOptions(dedupe(ddl.tags));
        } else if (metaFieldIds.tags) {
            getDropDownDataFromApi(metaFieldIds.tags)
                .then((d) => setTagOptions(dedupe(d?.values)))
                .catch(() => setTagOptions([]));
        }

        if (
            Array.isArray(ddl.attachmenttype) &&
            ddl.attachmenttype.length > 0
        ) {
            setAttachmentTypeOptions(dedupe(ddl.attachmenttype));
        } else if (metaFieldIds.attachmentType) {
            getDropDownDataFromApi(metaFieldIds.attachmentType)
                .then((d) => setAttachmentTypeOptions(dedupe(d?.values)))
                .catch(() => setAttachmentTypeOptions([]));
        }

        getMultipleDocImagesFromPDF();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderPdfPages = async (pdfBlobUrl, docId, onPageReady) => {
        const pdf = await getDocument(pdfBlobUrl).promise;
        const total = pdf.numPages;
        const pages = [];
        const CONCURRENCY = 5;

        const renderPage = async (pageNum) => {
            const page = await pdf.getPage(pageNum);
            const viewport = page.getViewport({ scale: 1.0 });
            const canvas = document.createElement('canvas');
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            const context = canvas.getContext('2d');
            await page.render({ canvasContext: context, viewport }).promise;
            const dataUrl = canvas.toDataURL('image/jpeg', 1.0);

            const result = {
                base64: dataUrl,
                pageIndex: pageNum - 1,
                docId,
                rotate: 0,
                originalDocumentPageIndex: pageNum - 1,
            };
            pages.push(result);
            if (onPageReady) onPageReady(result, pages.length, total);
            return result;
        };

        for (let i = 1; i <= total; i += CONCURRENCY) {
            const batch = [];
            for (let j = i; j <= Math.min(i + CONCURRENCY - 1, total); j++) {
                batch.push(renderPage(j));
            }
            await Promise.all(batch);
        }

        return pages.sort((a, b) => a.pageIndex - b.pageIndex);
    };

    const getMultipleDocImagesFromPDF = async () => {
        setBlurSpinner(true);
        setShowImage(false);

        const docids = getDocIds();
        const loadedDocs = [];

        // Pages stream in fast (multiple per frame). Coalesce all updates that
        // happen within a single animation frame into one setState so React
        // only reconciles once per frame instead of once per page. This keeps
        // the UI responsive even while dozens of pages are rendering.
        const pendingByDoc = new Map(); // docId -> { pages: [...], done: bool }
        let rafId = null;
        let firstPaint = true;

        const flushUpdates = () => {
            rafId = null;
            if (pendingByDoc.size === 0) return;

            // Snapshot-and-clear so any pages queued after this point are
            // collected into the next animation-frame flush.
            const batch = new Map(pendingByDoc);
            pendingByDoc.clear();

            setImgUrlObj((prev) => {
                let touched = false;
                const next = prev.map((doc) => {
                    const entry = batch.get(doc.docId);
                    if (!entry) return doc;
                    touched = true;
                    const merged = doc.imageUrl ? doc.imageUrl.slice() : [];
                    for (const p of entry.pages) merged[p.pageIndex] = p;
                    return { ...doc, imageUrl: merged, loading: !entry.done };
                });
                return touched ? next : prev;
            });

            if (firstPaint) {
                firstPaint = false;
                setShowImage(true);
                setBlurSpinner(false);
            }
        };

        const scheduleFlush = () => {
            if (rafId != null) return;
            rafId =
                typeof window !== 'undefined' && window.requestAnimationFrame
                    ? window.requestAnimationFrame(flushUpdates)
                    : setTimeout(flushUpdates, 16);
        };

        const queuePage = (docid, pageData, done) => {
            let entry = pendingByDoc.get(docid);
            if (!entry) {
                entry = { pages: [], done: false };
                pendingByDoc.set(docid, entry);
            }
            entry.pages.push(pageData);
            if (done) entry.done = true;
            scheduleFlush();
        };

        const loadDocument = async (encodedId) => {
            const docid = window.atob(encodedId);
            let blobUrl = null;
            try {
                const metadata = await getDocumentMetaWithDocId({ docid });
                const initialDocName =
                    metadata.miscPproperties.documentName ||
                    `Document ${docid}`;
                const pageCount = metadata.miscPproperties.pageCount || 0;

                const placeholders = Array.from(
                    { length: pageCount },
                    (_, i) => ({
                        base64: null,
                        isPlaceholder: true,
                        pageIndex: i,
                        docId: docid,
                        rotate: 0,
                        originalDocumentPageIndex: i,
                    })
                );

                const docData = {
                    docId: docid,
                    imageUrl: placeholders,
                    docName: initialDocName,
                    parentId: docid,
                    uniqueId: Math.random(),
                    loading: true,
                    // Per-document indexing metadata (set by the user while
                    // splitting / merging).  The "*Dirty" flags let us skip
                    // sending unchanged keywords for existing documents.
                    tags: [],
                    tagsDirty: false,
                    attachmentType: '',
                    attachmentTypeDirty: false,
                    faxDetail: '',
                    faxDetailDirty: false,
                };

                setImgUrlObj((prev) => [...prev, docData]);
                setShowImage(true);
                setBlurSpinner(false);

                const response = await downloadDoc(docid);
                if (response?.status === 400) {
                    toast.error('No PDF to load');
                    setImgUrlObj((prev) =>
                        prev.map((doc) =>
                            doc.docId === docid
                                ? { ...doc, loading: false }
                                : doc
                        )
                    );
                    return;
                }

                if (!response || !response.ok) {
                    setImgUrlObj((prev) =>
                        prev.map((doc) =>
                            doc.docId === docid
                                ? { ...doc, loading: false }
                                : doc
                        )
                    );
                    return;
                }

                const blob = await response.blob();
                blobUrl = URL.createObjectURL(blob);

                const fullPages = await renderPdfPages(
                    blobUrl,
                    docid,
                    (newPage, current, total) => {
                        const pending = pendingRenderTargets.current.get(docid);
                        if (current >= total)
                            pendingRenderTargets.current.delete(docid);
                        setImgUrlObj((prev) =>
                            prev.map((doc) => {
                                // Merge: non-keep doc's pages are redirected to the merged doc by uniqueId
                                if (pending?.type === 'merge') {
                                    if (doc.uniqueId !== pending.targetUniqueId)
                                        return doc;
                                    const newImageUrl = [...doc.imageUrl];
                                    const slot =
                                        pending.pageOffset + newPage.pageIndex;
                                    if (slot < newImageUrl.length)
                                        newImageUrl[slot] = newPage;
                                    return {
                                        ...doc,
                                        imageUrl: newImageUrl,
                                        loading: newImageUrl.some(
                                            (p) => p.base64 === null
                                        ),
                                    };
                                }
                                // Split/break/default: route by renderDocId + renderPageStart
                                const renderSource =
                                    doc.renderDocId || doc.docId;
                                if (renderSource !== docid) return doc;
                                const localSlot =
                                    newPage.pageIndex -
                                    (doc.renderPageStart || 0);
                                if (
                                    localSlot < 0 ||
                                    localSlot >= doc.imageUrl.length
                                )
                                    return doc;
                                const newImageUrl = [...doc.imageUrl];
                                newImageUrl[localSlot] = newPage;
                                return {
                                    ...doc,
                                    imageUrl: newImageUrl,
                                    loading: newImageUrl.some(
                                        (p) => p.base64 === null
                                    ),
                                };
                            })
                        );
                    }
                );

                const finalDocData = {
                    ...docData,
                    imageUrl: fullPages,
                    loading: false,
                };

                loadedDocs.push(finalDocData);

                if (Array.isArray(metadata?.fields)) {
                    setAllFields((prev) => ({
                        ...prev,
                        [docid]: metadata.fields,
                    }));

                    // Pre-populate the labelling controls from the document's
                    // existing keywords so users can see and edit the current
                    // tags / attachment type / fax detail in place.
                    const findValue = (fid) => {
                        if (fid == null) return '';
                        const f = metadata.fields.find(
                            (x) => x && x.fieldId === fid
                        );
                        return String(f?.value ?? '');
                    };

                    const initialTags = findValue(metaFieldIds.tags)
                        .split('|')
                        .map((t) => t.trim())
                        .filter((t) => t.length > 0);
                    const initialAttachmentType = findValue(
                        metaFieldIds.attachmentType
                    ).trim();
                    const initialFaxDetail = findValue(metaFieldIds.faxDetail);

                    finalDocData.tags = initialTags;
                    finalDocData.attachmentType = initialAttachmentType;
                    finalDocData.faxDetail = initialFaxDetail;

                    setImgUrlObj((prev) =>
                        prev.map((doc) =>
                            doc.docId === docid
                                ? {
                                      ...doc,
                                      tags: initialTags,
                                      attachmentType: initialAttachmentType,
                                      faxDetail: initialFaxDetail,
                                  }
                                : doc
                        )
                    );
                }
            } catch (error) {
                console.error(`Failed to process document ${docid}:`, error);
            } finally {
                if (blobUrl) {
                    try {
                        URL.revokeObjectURL(blobUrl);
                    } catch (e) {
                        /* noop */
                    }
                }
            }
        };

        await Promise.all(docids.map(loadDocument));

        // Final flush in case the last pages arrived between frames.
        if (rafId != null) {
            if (typeof window !== 'undefined' && window.cancelAnimationFrame) {
                window.cancelAnimationFrame(rafId);
            } else {
                clearTimeout(rafId);
            }
            rafId = null;
        }
        flushUpdates();

        setOriginalImgUrlObj(JSON.parse(JSON.stringify(loadedDocs)));
        setShowImage(true);
        setBlurSpinner(false);
    };

    const getDocIds = () => {
        // editIds (from ?editmultiple= query param) is always the canonical
        // source of base64-encoded document IDs — prefer it when available.
        if (editIds !== null && editIds !== undefined && editIds !== '') {
            return editIds.split('/').filter(Boolean);
        }

        let pathname = '';

        if (props.location !== undefined) {
            pathname = props.location.pathname;
        } else if (location !== undefined) {
            pathname = location.pathname;
        }

        if (!pathname) return [];

        let path_arr = [];
        if (pathname.includes('editmultiple=')) {
            const splitArray = pathname.split('editmultiple=');
            path_arr = splitArray[1].split('/').filter(Boolean);
        } else {
            path_arr = pathname.split('/').filter(Boolean);
        }

        return path_arr;
    };

    const overallSaveActionTransformation = async () => {
        console.log('deleteDocIds', deleteDocIds);
        setBlurSpinner(true);

        const idsToDelete = new Set(deleteDocIds);

        const transformations = [];

        imgUrlObj.forEach((doc) => {
            const activePages = (doc.imageUrl || []).filter(
                (p) => p.base64 != null && !p.base64.includes('deleted:1')
            );

            const pages = activePages.map((p) => {
                if (p.isDuplicated) {
                    // If the duplicated page came from an existing document, send
                    // a page reference so the backend can copy it natively without
                    // re-encoding it as a rasterised image.
                    if (
                        p.docId &&
                        p.docId !== 'upload' &&
                        p.originalDocumentPageIndex != null
                    ) {
                        return {
                            docId: p.docId,
                            pageIndex: p.pageIndex,
                            originalDocumentPageIndex:
                                p.originalDocumentPageIndex,
                            rotate: p.rotate || 0,
                        };
                    }
                    return {
                        base64: p.base64,
                        pageIndex: p.pageIndex,
                        rotate: p.rotate || 0,
                    };
                }
                if (p.isNewPage) {
                    if (
                        p.docId &&
                        p.docId !== 'upload' &&
                        p.originalDocumentPageIndex != null
                    ) {
                        return {
                            docId: p.docId,
                            pageIndex: p.pageIndex,
                            originalDocumentPageIndex:
                                p.originalDocumentPageIndex,
                            rotate: p.rotate || 0,
                        };
                    }
                    return {
                        base64: p.base64,
                        pageIndex: p.pageIndex,
                        rotate: p.rotate || 0,
                    };
                }

                if (p.isUploaded || p.originalDocumentPageIndex == null) {
                    return {
                        base64: p.base64,
                        pageIndex: p.pageIndex,
                        rotate: p.rotate || 0,
                    };
                }
                return {
                    docId: p.docId,
                    pageIndex: p.pageIndex,
                    originalDocumentPageIndex: p.originalDocumentPageIndex,
                    rotate: p.rotate || 0,
                };
            });

            const isUpload = doc.docId === 'upload';

            // Start with parent keywords for new docs so split documents inherit
            // the parent's metadata.  Existing documents keep their keywords
            // unchanged unless the user explicitly edited a labelling field.
            let newKeywords = isUpload
                ? [...(allFields[doc.docId] ?? allFields[doc.parentId] ?? [])]
                : [];

            // Push or replace a single keyword in the working list.  Used
            // below to persist the user-chosen Tags / Attachment Type / Fax
            // Detail values onto the resulting document(s).
            const upsertKeyword = (fieldId, value) => {
                if (fieldId == null) return;
                newKeywords = newKeywords.filter(
                    (k) => k && k.fieldId !== fieldId
                );
                newKeywords.push({ fieldId, value });
            };

            // Tags are stored as a single pipe-delimited keyword value with a
            // trailing pipe, matching the existing inbox tag-update flow.
            if (
                metaFieldIds.tags !== null &&
                (isUpload || doc.tagsDirty === true)
            ) {
                const tagList = Array.isArray(doc.tags) ? doc.tags : [];
                const tagValue =
                    tagList.length > 0 ? `${tagList.join('|')}|` : '';
                upsertKeyword(metaFieldIds.tags, tagValue);
            }

            // Attachment Type is a single value chosen from a dropdown.
            if (
                metaFieldIds.attachmentType !== null &&
                (isUpload || doc.attachmentTypeDirty === true)
            ) {
                upsertKeyword(
                    metaFieldIds.attachmentType,
                    String(doc.attachmentType ?? '').trim()
                );
            }

            // Fax Detail is free text.
            if (
                metaFieldIds.faxDetail !== null &&
                (isUpload || doc.faxDetailDirty === true)
            ) {
                upsertKeyword(
                    metaFieldIds.faxDetail,
                    String(doc.faxDetail ?? '')
                );
            }

            if (!isUpload && pages.length === 0) {
                idsToDelete.add(doc.docId);
                return;
            }

            if (pages.length > 0) {
                transformations.push({
                    action: isUpload ? 'create' : 'update',
                    ...(isUpload
                        ? {
                              parentDocId: doc.parentId,
                              targetTypeId: 0,
                          }
                        : {
                              sourceDocId: doc.docId,
                          }),
                    pages,
                    newKeywords,
                });
            }
        });

        try {
            if (transformations.length > 0) {
                const ids = transformations.map((t) => t.sourceDocId);
                await releaseLocks(ids);
                const res = await transformDocuments({ transformations });
                if (!res?.success) throw new Error('transform failed');
            }

            const idsToDeleteArray = Array.from(idsToDelete).filter(
                (id) => id !== 'upload' && !lockedDocument.includes(id)
            );

            if (idsToDeleteArray.length > 0) {
                const isInboxPath = location.pathname.includes('inbox');
                const queueType = isInboxPath ? 'inbox' : 'outbox';
                const queueStore = reduxStore[queueType]?.[queueType];
                const processId = queueStore?.processId;
                const statusId = queueStore?.statusId;
                const queueActions =
                    processId && statusId
                        ? getActions(null, processId, statusId)
                        : [];
                const deleteActionId = queueActions.indexOf('Delete');

                let deleteFailed = false;
                if (deleteActionId !== -1) {
                    const res = await deleteDocument({
                        processId,
                        statusId,
                        actionId: deleteActionId,
                        docIds: idsToDeleteArray.map(Number),
                        fields: [],
                    });
                    if (res && !res.ok && res.status !== 204)
                        deleteFailed = true;
                } else {
                    const deleteResults = await Promise.all(
                        idsToDeleteArray.map((id) => deleteMultipleDocument(id))
                    );
                    if (
                        deleteResults.some(
                            (r) => r && !r.ok && r.status !== 204
                        )
                    )
                        deleteFailed = true;
                }

                if (deleteFailed) {
                    toast.error('Failed to delete source document(s)');
                }
            }

            toast.success('Documents updated successfully');

            setTimeout(() => {
                dispatch(inboxPage({ multiple_edit_page: false }));
                dispatch(outboxPage({ multiple_edit_page: false }));

                const redirect = (type) => {
                    const store = reduxStore[type][type];
                    const processId = store.processId;
                    const statusId = store.statusId;
                    let subMenuName = '';

                    reduxStore.configReducerPersist.configData.menuItems
                        .filter(
                            (m) =>
                                m.menuName ===
                                type.charAt(0).toUpperCase() + type.slice(1)
                        )
                        .forEach((m) =>
                            m.processes.forEach((p) =>
                                p.statuses.forEach((s) => {
                                    if (s.statusId === statusId) {
                                        subMenuName =
                                            formatNameWithSpaceToUnderscore(
                                                s.name
                                            );
                                    }
                                })
                            )
                        );

                    history.push(
                        `/${type}/${subMenuName}/${processId}/${statusId}`
                    );
                };

                if (location.pathname.includes('inbox/detail'))
                    redirect('inbox');
                else if (location.pathname.includes('outbox/detail'))
                    redirect('outbox');
                else if (location.pathname.includes('reports')) {
                    dispatch(deletedPage({ hideSmallView: false }));
                    history.push(reduxStore.search.deletedPage.reportRedirect);
                } else {
                    history.goBack();
                }

                if (props.calingFrom !== 'Report') props.refreshTable();
            }, 1000);
        } catch (err) {
            console.error(err);
            toast.error('Error updating documents');
        } finally {
            setBlurSpinner(false);
        }
    };

    const cancelChanges = async () => {
        setBlurSpinner(true);
        const docids = getDocIds();
        const ids = docids
            .map((s) => {
                try {
                    return parseInt(window.atob(s), 10);
                } catch {
                    return NaN;
                }
            })
            .filter(Number.isFinite);
        await releaseLocks(ids);
        history.goBack();
        if (props.refreshTable) props.refreshTable();
        const isInbox = props.callingFrom === 'inboxPage';
        const pageAction = isInbox ? inboxPage : outboxPage;
        dispatch(pageAction({ multiple_edit_page: false }));
        const path = String(location.pathname);
        const isDetail = path.includes(
            isInbox ? 'inbox/detail' : 'outbox/detail'
        );
        if (isDetail) {
            dispatch(pageAction({ related_doc_detail: true }));
        }
    };

    const releaseLocks = async (lockedDocumentIds) => {
        for (const docId of lockedDocumentIds) {
            try {
                await unlockDocument(docId);
            } catch (e) {
                console.error(`Failed to unlock document ${docId}`, e);
            }
        }
    };

    const setSeparator = (event, imageIndex, documentSectionId) => {
        checkboxRef.current.checked = false;
        event.stopPropagation();
        classActiveSingle(event, 'separator_cut', 'sel');

        const result = applySplit(imgUrlObj, documentSectionId, imageIndex);
        if (!result.ok) {
            toast.error(result.reason);
            return;
        }

        setShowImage(false);
        setResetArray(result.next);
        setImgUrlObj(result.next);
        setShowImage(true);
        showMergeBreakSection();
    };

    const activeImage = async (event) => {
        let className = 'active';
        let avoidClassName = 'deleted';

        if (event.target.parentNode.classList.contains(avoidClassName)) {
            event.target.parentNode.classList.remove(avoidClassName);

            await setShowImage(false);

            await setShowImage(true);
            setOpenDelete(false);

            return true;
        }
        if (event.target.parentNode.classList.contains(className)) {
            event.target.parentNode.classList.remove(className);
            var indexInactive = imageActiveUrl.indexOf(
                event.target.parentNode.getAttribute('data-image')
            );

            if (indexInactive > -1) {
                imageActiveUrl.splice(indexInactive, 1);
            }
            if (pushSelectDatas.length) {
                pushSelectDatas.forEach((SelectDatas, index) => {
                    if (
                        SelectDatas.docsecid !== null &&
                        SelectDatas.index !== null
                    ) {
                        let docsecidRemove = SelectDatas.docsecid.indexOf(
                            event.target.parentNode.getAttribute(
                                'data-docsecid'
                            )
                        );
                        let indexRemove = SelectDatas.index.indexOf(
                            event.target.parentNode.getAttribute('data-index')
                        );
                        if (docsecidRemove > -1 && indexRemove > -1) {
                            pushSelectDatas.splice(index, 1);
                        }
                    }
                });
            }
        } else {
            event.target.parentNode.classList.add(className);
            imageActiveUrl.push(
                event.target.parentNode.getAttribute('data-image')
            );
            cutCopyDocName =
                event.target.parentNode.getAttribute('data-docname');
            cutCopyParentId =
                event.target.parentNode.getAttribute('data-docparentid');

            pushSelectDatas.push({
                docsecid: event.target.parentNode.getAttribute('data-docsecid'),
                index: event.target.parentNode.getAttribute('data-index'),
            });
            setSelectedData(pushSelectDatas);
        }

        let activeCount =
            document.getElementsByClassName('pdf-image active').length;
        document.getElementById('merge-break-section').style.display = 'none';
        document.getElementById('duplicate-doc').style.display = 'none';
        document.getElementById('rotate-section').style.display = 'none';
        document.getElementById('new-doc-section').style.display = 'none';
        document.getElementById('multiple-delete').style.display = 'none';
        document.getElementById('unselect').style.display = 'none';
        if (activeCount >= 1) {
            if (parseInt(activeCount) === 1) {
                document.getElementById('duplicate-doc').style.display =
                    'inline-block';
            }
            document.getElementById('new-doc-section').style.display =
                'inline-block';

            document.getElementById('rotate-section').style.display =
                'inline-flex';
            document.getElementById('multiple-delete').style.display =
                'inline-block';
            document.getElementById('unselect').style.display = 'inline-block';
        } else {
            document.getElementById('merge-break-section').style.display =
                'inline-block';
        }
    };

    const unselectDocument = async () => {
        checkboxRef.current.checked = false;
        setShowImage(false);
        let activeElem = document.querySelectorAll('.pdf-image.active');
        for (let i = 0; i < activeElem.length; i++) {
            activeElem[i].classList.remove('active');
        }
        await setImgActiveUrlObj([]);
        await setSelectedData([]);
        showMergeBreakSection();
        setShowBreakDoc(false);
        setSelDocForBreak([]);
        setShowImage(true);
    };

    const updateDocAttachmentType = (docIndex, value) => {
        setImgUrlObj((prev) =>
            prev.map((doc, idx) =>
                idx === parseInt(docIndex, 10)
                    ? {
                          ...doc,
                          attachmentType: value,
                          attachmentTypeDirty: true,
                      }
                    : doc
            )
        );
    };

    const updateDocFaxDetail = (docIndex, value) => {
        setImgUrlObj((prev) =>
            prev.map((doc, idx) =>
                idx === parseInt(docIndex, 10)
                    ? { ...doc, faxDetail: value, faxDetailDirty: true }
                    : doc
            )
        );
    };

    const toggleDocTag = (docIndex, tagName) => {
        const target = parseInt(docIndex, 10);
        setImgUrlObj((prev) =>
            prev.map((doc, idx) => {
                if (idx !== target) return doc;
                const list = Array.isArray(doc.tags) ? doc.tags : [];
                const exists = list.some(
                    (t) => t.toLowerCase() === tagName.toLowerCase()
                );
                const next = exists
                    ? list.filter(
                          (t) => t.toLowerCase() !== tagName.toLowerCase()
                      )
                    : [...list, tagName];
                return { ...doc, tags: next, tagsDirty: true };
            })
        );
    };

    const removeDocTag = (docIndex, tagName) => {
        const target = parseInt(docIndex, 10);
        setImgUrlObj((prev) =>
            prev.map((doc, idx) => {
                if (idx !== target) return doc;
                const list = Array.isArray(doc.tags) ? doc.tags : [];
                return {
                    ...doc,
                    tags: list.filter(
                        (t) => t.toLowerCase() !== tagName.toLowerCase()
                    ),
                    tagsDirty: true,
                };
            })
        );
    };

    const tagColorFor = (tagName) => {
        const c = tagColorByName[String(tagName ?? '').toLowerCase()];
        return c || '#6c7a89';
    };

    // Close the tag picker when the user clicks outside of it.
    useEffect(() => {
        if (openTagPickerFor === null) return undefined;
        const handler = (e) => {
            const target = e.target;
            if (
                target instanceof Element &&
                !target.closest('.doc-tag-picker-wrapper')
            ) {
                setOpenTagPickerFor(null);
                setTagFilter('');
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [openTagPickerFor]);

    const handleNewPages = (newPages) => {
        setImgUrlObj((prev) =>
            prev.map((doc) => {
                if (doc.docId !== targetDocId) return doc;

                const start = doc.imageUrl.length;
                const numbered = newPages.map((p, idx) => ({
                    ...p,
                    pageIndex: start + idx,
                    isUploaded: true,
                    docId: targetDocId,
                }));

                return { ...doc, imageUrl: [...doc.imageUrl, ...numbered] };
            })
        );
    };

    function showMergeBreakSection() {
        document.getElementById('unselect').style.display = 'none';
        document.getElementById('merge-break-section').style.display =
            'inline-block';
        document.getElementById('new-doc-section').style.display = 'none';
        document.getElementById('multiple-delete').style.display = 'none';
        document.getElementById('rotate-section').style.display = 'none';
    }

    const activeImageAppend = async () => {
        imgUrlObj.push({
            docId: 'upload',
            imageUrl: imageActiveUrl, //selectedImageArr
            docName: cutCopyDocName,
            parentId: cutCopyParentId,
            uniqueId: Math.random(),
            tags: [],
            tagsDirty: false,
            attachmentType: '',
            attachmentTypeDirty: false,
            faxDetail: '',
            faxDetailDirty: false,
        });
        await setResetArray(imgUrlObj);
        await setImgUrlObj(imgUrlObj);
    };

    const makeImageAsDeleted = () => {
        document.querySelectorAll('.pdf-image.active').forEach((active) => {
            active.classList.remove('active');
            active.classList.add('deleted');

            const docSecId = +active.getAttribute('data-docsecid');
            const base64Img = active.getAttribute('data-image'); // the original string

            const doc = imgUrlObj[docSecId];
            if (!doc) return;

            const pageObj = doc.imageUrl.find((p) => p.base64 === base64Img);
            if (!pageObj) return;

            const [, raw] = base64Img.split(',');
            pageObj.base64 = `data:image/png;deleted:1;base64,${raw}`;
        });
        setImgUrlObj([...imgUrlObj]);
    };

    const selctedImageExtract = () => {
        document.querySelectorAll('.pdf-image.active').forEach((active) => {
            const docSecId = +active.getAttribute('data-docsecid');
            const base64Img = active.getAttribute('data-image');

            const doc = imgUrlObj[docSecId];
            if (!doc) return;

            doc.imageUrl = doc.imageUrl.filter((p) => p.base64 !== base64Img);
        });

        setImgUrlObj([...imgUrlObj]);
    };

    const clearSelection = () => {
        document
            .querySelectorAll('.pdf-image.active')
            .forEach((el) => el.classList.remove('active'));
        setImgActiveUrlObj([]);
        setSelectedData([]);
        showMergeBreakSection();
    };

    const renumberPages = (pages) =>
        pages.map((p, idx) => ({ ...p, pageIndex: idx }));

    const copyDocument = () => {
        checkboxRef.current.checked = false;

        const activeEls = Array.from(
            document.querySelectorAll('.pdf-image.active')
        );
        if (activeEls.length === 0) return;

        const pages = activeEls.map((el, idx) => {
            const docIdx = +el.dataset.docsecid;
            const pageIdx = +el.dataset.index;
            const srcPage = imgUrlObj[docIdx]?.imageUrl[pageIdx];
            if (srcPage) {
                return { ...srcPage, pageIndex: idx, isNewPage: true };
            }
            return {
                base64: el.getAttribute('data-image'),
                pageIndex: idx,
                rotate: 0,
                isNewPage: true,
                docId: 'upload',
            };
        });

        setImgUrlObj((prev) => [
            ...prev,
            {
                docId: 'upload',
                parentId: cutCopyParentId,
                docName: cutCopyDocName || 'New Document',
                imageUrl: pages,
                uniqueId: Math.random(),
                tags: [],
                tagsDirty: false,
                attachmentType: '',
                attachmentTypeDirty: false,
                faxDetail: '',
                faxDetailDirty: false,
            },
        ]);

        clearSelection();
        setShowMergeDoc(false);
        setShowBreakDoc(true);
    };

    const cutDocument = () => {
        checkboxRef.current.checked = false;

        const activeEls = Array.from(
            document.querySelectorAll('.pdf-image.active')
        );
        if (activeEls.length === 0) return;

        const harvested = [];

        setImgUrlObj((prev) => {
            const next = prev.map((d) => ({ ...d, imageUrl: [...d.imageUrl] }));

            const sortedActiveEls = activeEls.sort((a, b) => {
                const docDiff = +a.dataset.docsecid - +b.dataset.docsecid;
                if (docDiff !== 0) return docDiff;
                return +b.dataset.index - +a.dataset.index;
            });

            const byDocument = {};
            sortedActiveEls.forEach((el) => {
                const docIdx = +el.dataset.docsecid;
                if (!byDocument[docIdx]) byDocument[docIdx] = [];
                byDocument[docIdx].push({
                    element: el,
                    pageIdx: +el.dataset.index,
                });
            });

            Object.entries(byDocument).forEach(([docIdx, pages]) => {
                const doc = next[+docIdx];
                if (!doc) return;

                pages.sort((a, b) => b.pageIdx - a.pageIdx);

                pages.forEach(({ pageIdx }) => {
                    if (pageIdx < doc.imageUrl.length) {
                        const removed = doc.imageUrl[pageIdx];
                        doc.imageUrl.splice(pageIdx, 1);

                        harvested.push({
                            ...removed,
                            isNewPage: true,
                            originalPageIndex:
                                removed.originalPageIndex ?? removed.pageIndex,
                        });
                    }
                });
                doc.imageUrl = renumberPages(doc.imageUrl);
            });

            if (harvested.length) {
                harvested.sort((a, b) => {
                    const aOriginal = a.originalPageIndex ?? a.pageIndex;
                    const bOriginal = b.originalPageIndex ?? b.pageIndex;
                    return aOriginal - bOriginal;
                });

                const newDoc = {
                    docId: 'upload',
                    parentId: cutCopyParentId,
                    docName: cutCopyDocName || 'Cut Document',
                    uniqueId: Math.random(),
                    imageUrl: renumberPages(
                        harvested.map((p, i) => ({
                            ...p,
                            pageIndex: i,
                        }))
                    ),
                    loading: false,
                    tags: [],
                    tagsDirty: false,
                    attachmentType: '',
                    attachmentTypeDirty: false,
                    faxDetail: '',
                    faxDetailDirty: false,
                };
                next.push(newDoc);
            }

            return next;
        });

        clearSelection();
        setShowMergeDoc(false);
        setShowBreakDoc(true);
        setShowImage(true);
    };

    const openBreakpointsPopup = async () => {
        setShowBreakPointPopup(true);
    };
    const mergeAllDocument = () => {
        checkboxRef.current.checked = false;

        // When nothing is explicitly selected, merge all docs in the view.
        // Otherwise resolve current imageUrl state for selected docs (entries may be stale).
        const selectedIds = new Set(selDocForBreak.map((d) => d.uniqueId));
        const currentDocs =
            selDocForBreak.length > 0
                ? imgUrlObj.filter((d) => selectedIds.has(d.uniqueId))
                : imgUrlObj;

        const result = applyMerge(imgUrlObj, currentDocs, lockedDocument);
        if (!result.ok) {
            toast.error(result.reason);
            return;
        }

        // Register pending render continuations for non-first loading docs, using the stable mergedUniqueId
        const lockedSet = new Set(lockedDocument);
        const mergeable = currentDocs.filter((d) => !lockedSet.has(d.docId));
        if (mergeable.length >= 2) {
            const [keep, ...others] = mergeable;
            let pageOffset = keep.imageUrl.length;
            others.forEach((doc) => {
                if (doc.loading) {
                    pendingRenderTargets.current.set(
                        doc.renderDocId || doc.docId,
                        {
                            type: 'merge',
                            targetUniqueId: result.mergedUniqueId,
                            pageOffset,
                        }
                    );
                }
                pageOffset += doc.imageUrl.length;
            });
        }

        result.deletedDocIds.forEach((id) => deleteDocIds.push(id));
        setResetArray(result.next);
        setImgUrlObj(result.next);
        if (result.next.length === 1) {
            setShowMergeDoc(true);
        }
        setShowBreakDoc(false);
        setSelDocForBreak([]);
        clearSelection();
    };

    const deleteMultiple = () => {
        let deleteCount =
            document.getElementsByClassName('pdf-image active').length;
        if (deleteCount > 0) {
            setOpenDelete(true);
            if (deleteCount > 1)
                setDeleteText(
                    'You are about to delete multiple pages. Are you sure you want to do this?'
                );
            else setDeleteText('');
        }
    };

    const handleCloseOperation = () => {
        setOpenDelete(false);
    };
    const handleBreakCloseOperation = () => {
        setShowBreakPointPopup(false);
    };
    const handleDeleteOperation = async () => {
        checkboxRef.current.checked = false;
        setShowImage(false);
        await makeImageAsDeleted(); //kalpana delete

        //selctedImageExtract();
        await setImgActiveUrlObj([]);
        await setSelectedData([]);

        setShowImage(true);
        setOpenDelete(false);
        showMergeBreakSection();
    };
    const handleBreakOperation = (breakValue) => {
        checkboxRef.current.checked = false;

        const result = applyBreak(
            imgUrlObj,
            selDocForBreak,
            breakValue,
            lockedDocument
        );
        if (!result.ok) {
            toast.error(result.reason);
            return;
        }

        setShowImage(false);
        setResetArray(result.next);
        setImgUrlObj(result.next);

        setShowBreakPointPopup(false);
        setShowImage(true);
        setShowBreakDoc(true);
        setShowMergeDoc(false);
        setSelDocForBreak([]);
    };

    const showSelctedImage = () => {
        pushSelectDatas.forEach((selectedDatas, index) => {
            let pdfImage = document.querySelectorAll(
                '.pdf-image[data-docsecid="' +
                    selectedDatas.docsecid +
                    '"][data-index="' +
                    selectedDatas.index +
                    '"]'
            );
            for (let i = 0; i < pdfImage.length; i++) {
                pdfImage[i].classList.add('active');
            }
        });
    };

    const duplicateDocument = () => {
        checkboxRef.current.checked = false;

        const activeEls = Array.from(
            document.querySelectorAll('.pdf-image.active')
        );
        if (activeEls.length === 0) return;

        setImgUrlObj((prev) => {
            const next = prev.map((d) => ({ ...d, imageUrl: [...d.imageUrl] }));

            activeEls.forEach((el) => {
                const docIdx = +el.dataset.docsecid;
                const pageIdx = +el.dataset.index;
                const doc = next[docIdx];
                if (!doc) return;

                const srcPage = { ...doc.imageUrl[pageIdx] };
                const clone = {
                    ...srcPage,
                    pageIndex: doc.imageUrl.length,
                    isNewPage: true,
                    isDuplicated: true,
                    originalPageIndex:
                        srcPage.originalPageIndex ??
                        srcPage.originalDocumentPageIndex ??
                        srcPage.pageIndex,
                    docId: srcPage?.isNewPage ? 'upload' : srcPage.docId,
                };
                doc.imageUrl.push(clone);
                doc.imageUrl = renumberPages(doc.imageUrl);
            });

            return next;
        });

        clearSelection();
    };

    const handleDocumentToggle = (event, i) => {
        setDocumentToggle(!documentToggle);
        let classNameOpen = 'doc-open';
        let classNameClose = 'doc-close';
        if (
            document
                .getElementById('document-section-' + i)
                .classList.contains(classNameOpen)
        ) {
            document
                .getElementById('document-section-' + i)
                .classList.remove(classNameOpen);
            document
                .getElementById('document-section-' + i)
                .classList.add(classNameClose);
            document
                .getElementById('doc-outer-sec-' + i)
                .classList.remove(classNameOpen);
            document
                .getElementById('doc-outer-sec-' + i)
                .classList.add(classNameClose);
        } else {
            document
                .getElementById('document-section-' + i)
                .classList.add(classNameOpen);
            document
                .getElementById('document-section-' + i)
                .classList.remove(classNameClose);
            document
                .getElementById('doc-outer-sec-' + i)
                .classList.add(classNameOpen);
            document
                .getElementById('doc-outer-sec-' + i)
                .classList.remove(classNameClose);
        }
    };

    const performRoatateperformRoatate = async (rotateDegree) => {
        let activeEle = document.querySelectorAll('.pdf-image.active');
        for (let i = 0; i < activeEle.length; i++) {
            let imageSrcValue = activeEle[i].getAttribute('data-image');
            let imageDocSection = activeEle[i].getAttribute('data-docsecid');
            let imageDocIndex = activeEle[i].getAttribute('data-index');

            rotate(imageSrcValue, rotateDegree, function (resultBase64) {
                let currentActiveEle = activeEle[i].getElementsByClassName(
                    'multiple-edit-image'
                )[0];
                currentActiveEle.setAttribute('src', resultBase64);
                activeEle[i].setAttribute('data-image', resultBase64);

                imgUrlObj.forEach((data, i) => {
                    if (parseInt(imageDocSection) === parseInt(i)) {
                        data.imageUrl.splice(imageDocIndex, 1, resultBase64);
                    }
                });
            });
        }
        await setImgUrlObj(imgUrlObj);
        await setImgActiveUrlObj([]);
        await setSelectedData([]);
        showMergeBreakSection();
        setTimeout(() => {
            setShowImage(false);
            setShowImage(true);
        }, 0.05);
    };

    /* ------------------------------------------------------------------ */
    /* 1. Pure helper – returns a rotated base-64 string                   */
    /* ------------------------------------------------------------------ */
    const rotateBase64 = (srcBase64, degrees) =>
        new Promise((res) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = degrees % 180 === 0 ? img.width : img.height;
                canvas.height = degrees % 180 === 0 ? img.height : img.width;

                ctx.translate(canvas.width / 2, canvas.height / 2);
                ctx.rotate((degrees * Math.PI) / 180);
                ctx.drawImage(img, img.width / -2, img.height / -2);

                res(canvas.toDataURL()); // <-- new base64
            };
            img.src = srcBase64;
        });

    /* ------------------------------------------------------------------ */
    /* 2. Main handler – swap this for your old performRoatateperformRoatate */
    /* ------------------------------------------------------------------ */
    const rotateSelectedPages = (addDeg) => {
        document.querySelectorAll('.pdf-image.active').forEach((el) => {
            const docIdx = +el.dataset.docsecid;
            const pageIdx = +el.dataset.index;
            const pageObj = imgUrlObj[docIdx].imageUrl[pageIdx];

            pageObj.rotate = nextAngle(pageObj.rotate || 0, addDeg); // ①
            el.style.transform = `rotate(${pageObj.rotate}deg)`; // ②
        });

        setImgUrlObj([...imgUrlObj]); // force re-render
        // Keep the selection and rotate/delete toolbar visible so the user
        // can keep rotating or perform another action without re-selecting.
    };

    const nextAngle = (cur, add) => {
        const v = (cur + add + 360) % 360; // keep it in 0-359
        return v === 270 ? -90 : v; // we store -90 instead of 270
    };

    const rotate = (srcBase64, degrees, callback) => {
        const canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        let image = new Image();
        image.onload = function () {
            canvas.width = degrees % 180 === 0 ? image.width : image.height;
            canvas.height = degrees % 180 === 0 ? image.height : image.width;
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate((degrees * Math.PI) / 180);
            ctx.drawImage(image, image.width / -2, image.height / -2);
            callback(canvas.toDataURL());
        };
        image.src = srcBase64;
    };

    const resetDocument = async () => {
        try {
            setBlurSpinner(true);
            setShowImage(false);

            if (originalImgUrlObj && originalImgUrlObj.length > 0) {
                setImgUrlObj(JSON.parse(JSON.stringify(originalImgUrlObj)));
                setDisableReset(true);
                setSelectedData([]);
                setSelDocForBreak([]);
                setImgActiveUrlObj([]);
                showMergeBreakSection();
            } else {
                toast.error('No original state to reset.');
            }

            setTimeout(() => {
                setShowImage(true);
                setBlurSpinner(false);
            }, 200);
        } catch (error) {
            setBlurSpinner(false);
            toast.error('Failed to reset documents.');
        }
    };

    const setResetArray = (currentimgUrl) => {
        setDisableReset(false);
        if (resetDoc.length === 0) {
            resetDoc.push(lastReset);
        }

        var temp = [];
        currentimgUrl.map((img, index) => {
            var obj = {};
            obj.docId = img.docId;
            obj.docName = img.docName;
            var arr = [];
            img.imageUrl.map((base64) => {
                arr.push(base64);
            });
            obj.imageUrl = arr;
            temp.push(obj);
        });
        if (resetDoc.length > 6) {
            resetDoc.splice(0, 1);
            resetDoc.push(temp);
        } else {
            resetDoc.push(temp);
        }
    };

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const move = (
        source,
        destination,
        droppableSource,
        droppableDestination
    ) => {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);

        const [removed] = sourceClone.splice(droppableSource.index, 1);
        destClone.splice(droppableDestination.index, 0, removed);
        const result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;
        return result;
    };

    const onDragEnd = async (result) => {
        const { source, destination } = result;
        if (!destination) {
            return;
        }
        const sInd = +source.droppableId;
        const dInd = +destination.droppableId;

        const mainArray = imgUrlObj[sInd];
        if (parseInt(sInd) === parseInt(dInd)) {
            setShowImage(false);
            const items = reorder(
                mainArray.imageUrl,
                source.index,
                destination.index
            );

            mainArray.imageUrl = items;

            await setResetArray(imgUrlObj);
            await setImgUrlObj(imgUrlObj);
            setShowImage(true);
            showMergeBreakSection();
        } else {
            setShowImage(false);
            const maindArray = imgUrlObj[dInd];
            const result = move(
                mainArray.imageUrl,
                maindArray.imageUrl,
                source,
                destination
            );
            mainArray.imageUrl = result[sInd];
            maindArray.imageUrl = result[dInd];
            await setResetArray(imgUrlObj);
            await setImgUrlObj(imgUrlObj);
            setShowImage(true);
            showMergeBreakSection();
        }
    };

    const splitDocument = async () => {
        setShowImage(false);
        let splitDocSecid = document
            .getElementsByClassName('separator_cut sel')[0]
            .parentNode.getAttribute('data-docsecid');
        let splitDocIndex = document
            .getElementsByClassName('separator_cut sel')[0]
            .parentNode.getAttribute('data-index');
        let splitDocIndexRes = parseInt(splitDocIndex) + parseInt(1);
        imgUrlObj.forEach((data, i) => {
            if (parseInt(splitDocSecid) === parseInt(i)) {
                var splitVal = data.imageUrl.splice(splitDocIndexRes);

                imgUrlObj.push({
                    docId: 'upload',
                    imageUrl: splitVal,
                    docName: data.docName,
                    parentId: data.parentId,
                    uniqueId: Math.random(),
                    tags: Array.isArray(data.tags) ? [...data.tags] : [],
                    tagsDirty: data.tagsDirty === true,
                    attachmentType: data.attachmentType ?? '',
                    attachmentTypeDirty: data.attachmentTypeDirty === true,
                    faxDetail: data.faxDetail ?? '',
                    faxDetailDirty: data.faxDetailDirty === true,
                });
            }
        });
        await setResetArray(imgUrlObj);
        await setImgUrlObj(imgUrlObj);
        setShowImage(true);
    };

    const getListStyle = (isDraggingOver, isArrEmpty) => ({
        display: 'flex',
        overflow: isArrEmpty,
    });

    function getItemClass(isDragging) {
        return isDragging ? 'image-outer aaa on-drag-custom' : 'image-outer';
    }
    const getItemStyle = (isDragging, draggableStyle) => ({
        background: isDragging ? '#BFDFEE' : '', //grey
        border: isDragging ? '1px solid #007DBC' : '', //grey
        margin: isDragging ? '2px' : '', //grey
        padding: isDragging ? '0px' : '', //grey

        ...draggableStyle,
    });

    const getItemStyleInner = (isDragging, draggableStyle) => ({
        border: isDragging ? '1px solid #007DBC' : '', //grey
    });

    const classActiveSingle = (event, queryClass, activeClass) => {
        let querySelector = document.querySelectorAll(`.${queryClass}`);
        if (!event.target.classList.contains(activeClass)) {
            for (let i = 0; i < querySelector.length; i++) {
                querySelector[i].classList.remove(activeClass);
            }
            event.target.classList.add(activeClass);
        } else {
            event.target.classList.remove(activeClass);
        }
    };

    const selectAllDocument = () => {
        const allPages = document.querySelectorAll('.pdf-image:not(.deleted)');
        const isSelecting = !checkboxRef.current.checked;

        checkboxRef.current.checked = isSelecting;

        // Reset selection arrays
        imageActiveUrl.length = 0;
        pushSelectDatas.length = 0;

        if (isSelecting) {
            // Select all pages visually
            allPages.forEach((page) => {
                page.classList.add('active');
                imageActiveUrl.push(page.getAttribute('data-image'));
                pushSelectDatas.push({
                    docsecid: page.getAttribute('data-docsecid'),
                    index: page.getAttribute('data-index'),
                });
            });

            // Also add all documents to selDocForBreak
            const updatedSelDocs = [];
            Object.entries(imgUrlObj).forEach(([k, v]) => {
                if (!selDocForBreak.includes(v)) {
                    updatedSelDocs.push(v);
                }
            });
            setSelDocForBreak([...selDocForBreak, ...updatedSelDocs]);
        } else {
            // Unselect all pages
            allPages.forEach((page) => page.classList.remove('active'));
            setSelDocForBreak([]); // Clear document-level selection
        }

        // Update page selection state
        setImgActiveUrlObj([...imageActiveUrl]);
        setSelectedData([...pushSelectDatas]);

        // Update toolbar visibility
        document.getElementById('rotate-section').style.display = isSelecting
            ? 'inline-flex'
            : 'none';
        document.getElementById('multiple-delete').style.display = isSelecting
            ? 'inline-block'
            : 'none';
    };

    const selectDocument = (event, doc, docIndex) => {
        const isChecked = event.target.checked;
        let updatedSelDocs = [...selDocForBreak];
        let moreThanOnePage = false;

        // Resolve this document's actual position in imgUrlObj.
        // We can't look it up by docId because split documents all share
        // docId === "upload", so findIndex would return the first match
        // and select the wrong document's pages.
        const resolvedIndex =
            docIndex !== undefined && docIndex !== null
                ? String(docIndex)
                : String(imgUrlObj.indexOf(doc));

        const allDocPages = document.querySelectorAll(
            `.pdf-image[data-docsecid="${resolvedIndex}"]`
        );

        if (isChecked) {
            if (!updatedSelDocs.includes(doc)) {
                updatedSelDocs.push(doc);
            }

            allDocPages.forEach((page) => {
                if (!page.classList.contains('active')) {
                    page.classList.add('active');
                }
                const img = page.getAttribute('data-image');
                if (!imageActiveUrl.includes(img)) {
                    imageActiveUrl.push(img);
                }
                const docsecid = page.getAttribute('data-docsecid');
                const idx = page.getAttribute('data-index');
                if (
                    !pushSelectDatas.some(
                        (d) => d.docsecid === docsecid && d.index === idx
                    )
                ) {
                    pushSelectDatas.push({ docsecid, index: idx });
                }
            });
        } else {
            updatedSelDocs = updatedSelDocs.filter((item) => item !== doc);

            allDocPages.forEach((page) => {
                page.classList.remove('active');
                const img = page.getAttribute('data-image');
                const imgIndex = imageActiveUrl.indexOf(img);
                if (imgIndex > -1) imageActiveUrl.splice(imgIndex, 1);
                pushSelectDatas = pushSelectDatas.filter(
                    (d) =>
                        !(
                            d.docsecid === page.getAttribute('data-docsecid') &&
                            d.index === page.getAttribute('data-index')
                        )
                );
            });
        }

        updatedSelDocs.forEach((data) => {
            if (data.imageUrl.length > 1) {
                moreThanOnePage = true;
            }
        });

        setSelDocForBreak(updatedSelDocs);
        setImgActiveUrlObj([...imageActiveUrl]);
        setSelectedData([...pushSelectDatas]);

        // Sync "Select All" checkbox - only count selectable (unlocked) docs
        const selectableDocsCount = imgUrlObj.filter(
            (d) => !lockedDocument.includes(d.docId)
        ).length;
        checkboxRef.current.checked =
            selectableDocsCount > 0 &&
            updatedSelDocs.length === selectableDocsCount;

        // Toolbar updates
        document.getElementById('multiple-delete').style.display =
            updatedSelDocs.length > 0 ? 'inline-block' : 'none';
        document.getElementById('rotate-section').style.display =
            updatedSelDocs.length > 0 ? 'inline-flex' : 'none';

        setShowBreakDoc(!(moreThanOnePage === true));
        setShowMergeDoc(updatedSelDocs.length === 1);
    };

    // merge and break option using selected document (selDocForBreak)
    useEffect(() => {
        // Disable merge only when exactly 1 doc is selected (can't merge a single doc).
        // When 0 docs are selected, "Merge All" merges everything in the view.
        setShowMergeDoc(selDocForBreak.length === 1);
        var moreThanOnePage = false;
        selDocForBreak.map((data, index) => {
            if (data.imageUrl.length > 1) {
                moreThanOnePage = true;
            }
        });
        setShowBreakDoc(!(moreThanOnePage === true));
    }, [selDocForBreak]);

    const checkedAction = (doc) => {
        const getFilter = selDocForBreak.findIndex((item) => item === doc);
        return getFilter !== -1 ? true : false;
    };

    let docNumUpload = 0;

    latestPageHandlers.current = { activeImage, setSeparator };

    return (
        <>
            <div>
                <div className='multi_btns pr-4 back-button'>
                    {blurSpinner && (
                        <Button
                            variant='secondary'
                            title='Back'
                            className='btn-can btn'
                            onClick={() => {
                                if (originalImgUrlObj.length > 0) {
                                    setImgUrlObj(
                                        JSON.parse(
                                            JSON.stringify(originalImgUrlObj)
                                        )
                                    );
                                } else {
                                    history.goBack();
                                    return;
                                }

                                if (props.callingFrom === 'inboxPage') {
                                    dispatch(
                                        inboxPage({
                                            multiple_edit_page: false,
                                        })
                                    );
                                }
                                if (props.callingFrom !== 'inboxPage') {
                                    dispatch(
                                        outboxPage({
                                            multiple_edit_page: false,
                                        })
                                    );
                                }

                                if (
                                    String(location.pathname).includes(
                                        'outbox/detail'
                                    ) === true
                                ) {
                                    dispatch(
                                        outboxPage({
                                            related_doc_detail: true,
                                        })
                                    );
                                }
                                if (
                                    String(location.pathname).includes(
                                        'inbox/detail'
                                    ) === true
                                ) {
                                    dispatch(
                                        inboxPage({
                                            related_doc_detail: true,
                                        })
                                    );
                                }
                            }}
                        >
                            Back
                        </Button>
                    )}
                </div>
            </div>

            <div className='edit-loader'>
                <div className='right-aside edit_page print-page multi-page'>
                    <div className='row align-items-stretch justify-content-between mb-10 multiple-header'>
                        <div className='col align-items-center multi_edit_icons'>
                            <div
                                className='merge-break-section'
                                id='merge-break-section'
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <button
                                    id='merge-all'
                                    onClick={selectAllDocument}
                                    className='chk_all'
                                    disabled={
                                        imgUrlObj?.length ===
                                            lockedDocument.length ||
                                        anyDocLoading
                                    }
                                    style={{
                                        cursor:
                                            imgUrlObj?.length ===
                                                lockedDocument.length ||
                                            anyDocLoading
                                                ? 'not-allowed'
                                                : '',
                                    }}
                                >
                                    <label className='rdg-checkbox-label'>
                                        <input
                                            ref={checkboxRef}
                                            type='checkbox'
                                            className='merge-checkbox'
                                            disabled
                                        />
                                        <span className='rdg-checkbox'></span>
                                    </label>
                                    {checkboxRef && checkboxRef.current?.checked
                                        ? 'Unselect all'
                                        : 'Select all'}
                                </button>

                                <button
                                    disabled={showMergeDoc || anyDocLoading}
                                    id='merge-all'
                                    onClick={mergeAllDocument}
                                    style={{
                                        cursor:
                                            showMergeDoc || anyDocLoading
                                                ? 'not-allowed'
                                                : '',
                                    }}
                                    className={
                                        showMergeDoc || anyDocLoading
                                            ? 'disabled-merge'
                                            : ''
                                    }
                                >
                                    <i className='fa-light fa-diagram-venn'></i>
                                    Merge all
                                </button>
                                <button
                                    disabled={showBreakDoc || anyDocLoading}
                                    id='break-doc'
                                    onClick={openBreakpointsPopup}
                                    style={{
                                        cursor:
                                            showBreakDoc || anyDocLoading
                                                ? 'not-allowed'
                                                : '',
                                    }}
                                    className={
                                        showBreakDoc || anyDocLoading
                                            ? 'disabled-break'
                                            : ''
                                    }
                                >
                                    <svg
                                        className='icon-fill'
                                        style={{ marginRight: '5px' }}
                                        width='20'
                                        height='17'
                                        viewBox='0 0 100 100'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path d='M100,77c-4.7-3.5-9.4-7-13.9-10.5c-1.6-1.2-3.2-2.4-4.7-3.6c0,0.5,0,1,0,1.5l0,1.3c0,0.4,0,0.8,0,1.1  c0,0.1,0,0.2,0,0.3L81,72.8l-5.7,0.5c0,0-0.1,0-0.1,0c-0.2,0-0.5,0.1-1,0.1c-2,0-4,0-6,0c-4.4,0-8.9,0-13.3,0  c-3.6,0-6.7-1.7-8.8-4.9c-3.6-5.4-6.6-9.9-9.4-14.1c-0.9-1.4-1.4-2.9-1.4-4.4c0-1.5,0.5-3,1.4-4.4c3.2-4.8,6.4-9.5,9.4-14  c2.1-3.2,5.4-4.9,9.2-4.9c4.3,0,8.6,0,12.8,0c1.9,0,3.8,0,5.7,0c0.5,0,0.9,0,1.2,0.1c0.1,0,0.2,0,0.3,0l6.1,0.4v6.1  c0,0.9,0,1.9,0,2.8c0,0.3,0,0.7,0,1c0.5-0.4,1-0.7,1.5-1.1c5.6-4.2,11.4-8.6,17.2-12.9c-5-3.8-10.1-7.6-15.1-11.3  c-1.2-0.9-2.4-1.8-3.6-2.7c0,0.1,0,0.2,0,0.3c0,0.8,0,1.7,0,2.5v1.1v6.5h-6.5c-2.3,0-4.7,0-7,0c-5.2,0-10.6,0-15.8,0  c-4.3,0-7.4,1.5-9.9,5c-2.4,3.2-4.8,6.5-7.2,9.6c-1.9,2.6-3.9,5.2-5.9,7.8c-2.2,3-5.4,4.6-9.1,4.6c-3.2,0-6.4,0-9.6,0  c-3.4,0-6.9,0-10.3,0v7.3c3.2,0,6.3,0,9.4,0c3.4,0,6.9,0,10.3,0c3.9,0,7.2,1.6,9.5,4.8c2.4,3.2,4.8,6.5,7.2,9.6  c1.9,2.5,3.9,5.2,5.8,7.8c2.5,3.3,5.4,4.8,9.6,4.8c5.1,0,10.2,0,15.2,0c2.2,0,4.4,0,6.6,0h1.3h6.5v6.5c0,1,0,1.9,0,2.9  c0,0.4,0,0.7,0,1c1.3-1,2.7-2,4-3C90.1,84.4,95.1,80.6,100,77z' />
                                    </svg>
                                    Break Documents
                                </button>
                            </div>
                            <div
                                className='new-doc-section'
                                id='new-doc-section'
                                style={{ display: 'none' }}
                            >
                                <button
                                    id='duplicate-doc'
                                    onClick={duplicateDocument}
                                    style={{ display: 'none' }}
                                >
                                    <i className='fa-regular fa-clone'></i>
                                    Duplicate
                                </button>

                                <button id='copy-doc' onClick={copyDocument}>
                                    <i className='fa-regular fa-copy'></i>
                                    Copy into New Document
                                </button>
                                <button
                                    id='cut-doc'
                                    onClick={cutDocument}
                                    disabled={!allPagesRendered}
                                    style={{
                                        cursor: !allPagesRendered
                                            ? 'not-allowed'
                                            : '',
                                    }}
                                    className={
                                        !allPagesRendered
                                            ? 'disabled-merge'
                                            : ''
                                    }
                                >
                                    <i className='fa-regular fa-scissors'></i>
                                    Cut into New Document
                                </button>
                            </div>
                            <div className='text-edit' style={{ top: '10px' }}>
                                <button
                                    id='resetAction'
                                    onClick={resetDocument}
                                    disabled={disableReset}
                                    style={{
                                        cursor: disableReset
                                            ? 'not-allowed'
                                            : '',
                                    }}
                                    className={
                                        disableReset ? 'disabled-reset' : ''
                                    }
                                >
                                    <img
                                        alt='text-rotate'
                                        title='Rotate'
                                        src={
                                            window.location.origin +
                                            '/images/red-forward.svg'
                                        }
                                    />
                                </button>
                                <span
                                    className='editer-delete'
                                    onClick={deleteMultiple}
                                    id='multiple-delete'
                                    style={{ display: 'none' }}
                                >
                                    {/*  <i className='fas fa-trash-alt'></i>*/}
                                    <i className='fa-light fa-trash-can'></i>
                                </span>
                            </div>
                            <div
                                className='tbd text-edit'
                                id='rotate-section'
                                style={{ display: 'none' }}
                            >
                                <span onClick={() => rotateSelectedPages(-90)}>
                                    <i className='fa-regular fa-rotate-left' />
                                </span>
                                <span onClick={() => rotateSelectedPages(90)}>
                                    <i className='fa-regular fa-rotate-right' />
                                </span>
                            </div>
                            <button
                                className='ml-4'
                                onClick={unselectDocument}
                                id='unselect'
                                style={{ display: 'none' }}
                            >
                                Unselect all
                            </button>
                        </div>
                        <div className='multi_btns pr-4'>
                            <button
                                title='Cancel'
                                className='btn-can'
                                onClick={cancelChanges}
                            >
                                Cancel
                            </button>
                            <Button
                                variant='sucess'
                                title='Save & close'
                                disabled={
                                    showSaveButton ||
                                    imgUrlObj?.length === lockedDocument.length
                                }
                                className={
                                    showSaveButton ||
                                    imgUrlObj?.length === lockedDocument.length
                                        ? 'save-disabled btn-sav'
                                        : 'btn-sav'
                                }
                                onClick={overallSaveActionTransformation}
                                style={{
                                    cursor:
                                        showSaveButton ||
                                        imgUrlObj?.length ===
                                            lockedDocument.length
                                            ? 'not-allowed'
                                            : '',
                                }}
                            >
                                Save & close
                            </Button>
                        </div>
                    </div>

                    {openDelete ? (
                        <EditDeleteModal
                            openDelete={openDelete}
                            deleteText={deleteText}
                            handleDeleteOperation={handleDeleteOperation}
                            handleCloseOperation={handleCloseOperation}
                        />
                    ) : null}
                    {showBreakPointPopup ? (
                        <BreakPointModal
                            showBreakPointPopup={showBreakPointPopup}
                            handleBreakCloseOperation={
                                handleBreakCloseOperation
                            }
                            handleBreakOperation={handleBreakOperation}
                            //handleBreakPoint={handleBreakPoint}
                        />
                    ) : null}

                    {showImage ? (
                        imgUrlObj?.length > 0 ? (
                            <DragDropContext onDragEnd={onDragEnd}>
                                <div>
                                    {Object.entries(imgUrlObj).map(([k, v]) => {
                                        let isLocked = lockedDocument.includes(
                                            v.docId
                                        )
                                            ? true
                                            : false;

                                        let isArrayEmpty = 'auto';
                                        if (v.imageUrl?.base64?.length === 0) {
                                            isArrayEmpty = 'inherit';
                                        }
                                        // docNum++;
                                        let newArray = v;
                                        let i = k;
                                        let documentSectionId = k;
                                        let docIdName = v.docName;
                                        // 'Document ' +
                                        // docNum +
                                        // ' - ' +
                                        // newArray.docId;
                                        if (
                                            String(newArray.docId) === 'upload'
                                        ) {
                                            docNumUpload++;
                                            docIdName =
                                                'New Document ' +
                                                docNumUpload +
                                                ' (' +
                                                v.docName +
                                                ')';
                                        }
                                        const isTagPickerOpen =
                                            openTagPickerFor === k;
                                        const docTags = Array.isArray(v.tags)
                                            ? v.tags
                                            : [];
                                        const filteredTagOptions = (
                                            tagOptions || []
                                        ).filter((opt) =>
                                            String(opt)
                                                .toLowerCase()
                                                .includes(
                                                    tagFilter.toLowerCase()
                                                )
                                        );
                                        return (
                                            <div
                                                className={
                                                    isLocked
                                                        ? 'row document-row Locked-Document'
                                                        : 'row document-row'
                                                }
                                                key={i}
                                                data-docid={newArray.docId}
                                                id={`docment-row-${newArray.docId}`}
                                            >
                                                <div className='center-editor col-lg-12 col-sm-12'>
                                                    <div
                                                        id={`doc-outer-sec-${i}`}
                                                        className='document_title doc-open'
                                                    >
                                                        {isLocked && (
                                                            <i
                                                                className='fa fa-lock'
                                                                aria-hidden='true'
                                                            />
                                                        )}
                                                        {isLocked !== true && (
                                                            <label className='rdg-checkbox-label'>
                                                                <input
                                                                    onChange={(
                                                                        event
                                                                    ) => {
                                                                        if (
                                                                            checkboxRef &&
                                                                            checkboxRef
                                                                                .current
                                                                                ?.checked
                                                                        ) {
                                                                            checkboxRef.current.checked = false;
                                                                        }
                                                                        selectDocument(
                                                                            event,
                                                                            v,
                                                                            k
                                                                        );
                                                                    }}
                                                                    type='checkbox'
                                                                    className='merge-checkbox'
                                                                    checked={
                                                                        isLocked !==
                                                                            true &&
                                                                        checkedAction(
                                                                            v
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        isLocked ||
                                                                        v.loading
                                                                    }
                                                                />
                                                                <span className='rdg-checkbox'></span>
                                                            </label>
                                                        )}
                                                        <span>
                                                            <i
                                                                className='fa fa-chevron-up'
                                                                aria-hidden='true'
                                                                onClick={(
                                                                    event
                                                                ) =>
                                                                    handleDocumentToggle(
                                                                        event,
                                                                        i
                                                                    )
                                                                }
                                                            ></i>
                                                        </span>
                                                        <span>{docIdName}</span>
                                                        <Button
                                                            style={{
                                                                marginLeft:
                                                                    '10px',
                                                            }}
                                                            variant='primary'
                                                            onClick={() => {
                                                                setTargetDocId(
                                                                    newArray.docId
                                                                );
                                                                setUploadModalOpen(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            Add Pages
                                                        </Button>

                                                        {v.loading && (
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'inline',
                                                                    marginLeft:
                                                                        '15px',
                                                                    textAlign:
                                                                        'center',
                                                                }}
                                                            >
                                                                <Spinner
                                                                    animation='border'
                                                                    variant='primary'
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    {!isLocked && (
                                                        <div className='doc-meta-bar'>
                                                            {/* --- Tags ---------------------------------- */}
                                                            <div className='doc-meta-field doc-meta-tags'>
                                                                <span className='doc-meta-label'>
                                                                    <i className='fa-solid fa-tag' />
                                                                    Tags
                                                                </span>
                                                                <div className='doc-meta-control doc-tag-chips'>
                                                                    {docTags.length ===
                                                                        0 && (
                                                                        <span className='doc-meta-placeholder'>
                                                                            No
                                                                            tags
                                                                        </span>
                                                                    )}
                                                                    {docTags.map(
                                                                        (
                                                                            tag
                                                                        ) => (
                                                                            <span
                                                                                key={
                                                                                    tag
                                                                                }
                                                                                className='doc-tag-chip'
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        tagColorFor(
                                                                                            tag
                                                                                        ),
                                                                                }}
                                                                                title={
                                                                                    tag
                                                                                }
                                                                            >
                                                                                <span className='doc-tag-chip-name'>
                                                                                    {
                                                                                        tag
                                                                                    }
                                                                                </span>
                                                                                <button
                                                                                    type='button'
                                                                                    className='doc-tag-chip-x'
                                                                                    aria-label={`Remove ${tag}`}
                                                                                    onClick={() =>
                                                                                        removeDocTag(
                                                                                            k,
                                                                                            tag
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <i className='fa-light fa-xmark' />
                                                                                </button>
                                                                            </span>
                                                                        )
                                                                    )}
                                                                    <div className='doc-tag-picker-wrapper'>
                                                                        <button
                                                                            type='button'
                                                                            className='doc-tag-add-btn'
                                                                            onClick={() => {
                                                                                setTagFilter(
                                                                                    ''
                                                                                );
                                                                                setOpenTagPickerFor(
                                                                                    isTagPickerOpen
                                                                                        ? null
                                                                                        : k
                                                                                );
                                                                            }}
                                                                        >
                                                                            <i className='fa-light fa-plus' />
                                                                            <span>
                                                                                Add
                                                                                tag
                                                                            </span>
                                                                        </button>
                                                                        {isTagPickerOpen && (
                                                                            <div className='doc-tag-picker'>
                                                                                <input
                                                                                    type='text'
                                                                                    autoFocus
                                                                                    className='doc-tag-picker-search'
                                                                                    placeholder='Search tags…'
                                                                                    value={
                                                                                        tagFilter
                                                                                    }
                                                                                    onChange={(
                                                                                        e
                                                                                    ) =>
                                                                                        setTagFilter(
                                                                                            e
                                                                                                .target
                                                                                                .value
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <div className='doc-tag-picker-list'>
                                                                                    {filteredTagOptions.length ===
                                                                                    0 ? (
                                                                                        <div className='doc-tag-picker-empty'>
                                                                                            No
                                                                                            matching
                                                                                            tags
                                                                                        </div>
                                                                                    ) : (
                                                                                        filteredTagOptions.map(
                                                                                            (
                                                                                                opt
                                                                                            ) => {
                                                                                                const selected =
                                                                                                    docTags.some(
                                                                                                        (
                                                                                                            t
                                                                                                        ) =>
                                                                                                            t.toLowerCase() ===
                                                                                                            opt.toLowerCase()
                                                                                                    );
                                                                                                return (
                                                                                                    <button
                                                                                                        type='button'
                                                                                                        key={
                                                                                                            opt
                                                                                                        }
                                                                                                        className={`doc-tag-picker-item${
                                                                                                            selected
                                                                                                                ? ' is-selected'
                                                                                                                : ''
                                                                                                        }`}
                                                                                                        onClick={() => {
                                                                                                            toggleDocTag(
                                                                                                                k,
                                                                                                                opt
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        <span
                                                                                                            className='doc-tag-picker-swatch'
                                                                                                            style={{
                                                                                                                backgroundColor:
                                                                                                                    tagColorFor(
                                                                                                                        opt
                                                                                                                    ),
                                                                                                            }}
                                                                                                        />
                                                                                                        <span className='doc-tag-picker-name'>
                                                                                                            {
                                                                                                                opt
                                                                                                            }
                                                                                                        </span>
                                                                                                        {selected && (
                                                                                                            <i className='fa-solid fa-check' />
                                                                                                        )}
                                                                                                    </button>
                                                                                                );
                                                                                            }
                                                                                        )
                                                                                    )}
                                                                                </div>
                                                                                <div className='doc-tag-picker-footer'>
                                                                                    <button
                                                                                        type='button'
                                                                                        className='doc-tag-picker-close'
                                                                                        onClick={() =>
                                                                                            setOpenTagPickerFor(
                                                                                                null
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Done
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* --- Fax Detail --------------------------- */}
                                                            <div className='doc-meta-field doc-meta-fax'>
                                                                <span className='doc-meta-label'>
                                                                    <i className='fa-solid fa-fax' />
                                                                    Fax Detail
                                                                </span>
                                                                <div className='doc-meta-control'>
                                                                    <input
                                                                        type='text'
                                                                        className='doc-meta-input'
                                                                        placeholder='Enter fax detail'
                                                                        maxLength={
                                                                            250
                                                                        }
                                                                        value={
                                                                            v.faxDetail ??
                                                                            ''
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            updateDocFaxDetail(
                                                                                k,
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <Droppable
                                                        droppableId={k}
                                                        type='CARD'
                                                        direction='horizontal'
                                                        isCombineEnabled={false}
                                                        key={k}
                                                        isDropDisabled={
                                                            isLocked
                                                        }
                                                    >
                                                        {(
                                                            dropProvided,
                                                            snapshot
                                                        ) => (
                                                            <div
                                                                {...dropProvided.droppableProps}
                                                            >
                                                                <div
                                                                    className='document-section doc-open'
                                                                    id={`document-section-${i}`}
                                                                    data-index={
                                                                        i
                                                                    }
                                                                >
                                                                    <div
                                                                        className='image-flex'
                                                                        ref={
                                                                            dropProvided.innerRef
                                                                        }
                                                                        style={getListStyle(
                                                                            snapshot.isDraggingOver,
                                                                            isArrayEmpty
                                                                        )}
                                                                    >
                                                                        {v
                                                                            .imageUrl
                                                                            ?.length ||
                                                                        v.loading ? (
                                                                            <>
                                                                                {v.imageUrl?.map(
                                                                                    (
                                                                                        item,
                                                                                        index
                                                                                    ) => {
                                                                                        const pageImage =
                                                                                            item.base64;

                                                                                        return (
                                                                                            <DraggablePage
                                                                                                key={
                                                                                                    index
                                                                                                }
                                                                                                index={
                                                                                                    index
                                                                                                }
                                                                                                item={
                                                                                                    item
                                                                                                }
                                                                                                pageImage={
                                                                                                    pageImage
                                                                                                }
                                                                                                documentSectionId={
                                                                                                    documentSectionId
                                                                                                }
                                                                                                docName={
                                                                                                    v.docName
                                                                                                }
                                                                                                parentId={
                                                                                                    v.parentId
                                                                                                }
                                                                                                deletedPages={
                                                                                                    deletedPages
                                                                                                }
                                                                                                isLocked={
                                                                                                    isLocked
                                                                                                }
                                                                                                k={
                                                                                                    k
                                                                                                }
                                                                                                activeImage={
                                                                                                    stablePageHandlers
                                                                                                        .current
                                                                                                        .activeImage
                                                                                                }
                                                                                                setSeparator={
                                                                                                    stablePageHandlers
                                                                                                        .current
                                                                                                        .setSeparator
                                                                                                }
                                                                                                isDocumentLoading={
                                                                                                    v.loading
                                                                                                }
                                                                                                getItemClass={
                                                                                                    getItemClass
                                                                                                }
                                                                                                getItemStyle={
                                                                                                    getItemStyle
                                                                                                }
                                                                                                getItemStyleInner={
                                                                                                    getItemStyleInner
                                                                                                }
                                                                                                setZoomPage={
                                                                                                    setZoomPage
                                                                                                }
                                                                                                setZoomOpen={
                                                                                                    setZoomOpen
                                                                                                }
                                                                                            />
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <div className='empty-doc-sec'>
                                                                                The
                                                                                Document
                                                                                is
                                                                                empty
                                                                            </div>
                                                                        )}
                                                                        {
                                                                            dropProvided.placeholder
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </DragDropContext>
                        ) : null
                    ) : (
                        <div
                            className='kalpana'
                            style={{ height: window.innerHeight }}
                        ></div>
                    )}
                </div>
                {blurSpinner ? <SpinnerBlur show={blurSpinner} /> : null}
            </div>

            <UploadPagesModal
                show={uploadModalOpen}
                setShow={setUploadModalOpen}
                onPagesAdded={handleNewPages}
            />
            <ZoomModal
                show={zoomOpen}
                page={zoomPage}
                onHide={() => setZoomOpen(false)}
            />
        </>
    );
}

export default MultipleEditPage;
